import { useEffect, useState } from 'react'

/** Tailwind `md` breakpoint — below it we use the mobile navigation. */
export const MOBILE_BREAKPOINT = 768

/**
 * "Phone" = narrower than md, OR a touch device with a short viewport (a phone
 * in landscape is wider than md but only ~400px tall). Keep in sync with the
 * `max-md:` / `phone-landscape:` classes used in the layout.
 */
export const PHONE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px), ((hover: none) and (max-height: 500px))`

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window === 'undefined' ? false : window.matchMedia(PHONE_MEDIA_QUERY).matches
  )
  useEffect(() => {
    const media = window.matchMedia(PHONE_MEDIA_QUERY)
    const onChange = () => setIsMobile(media.matches)
    media.addEventListener('change', onChange)
    onChange()
    return () => media.removeEventListener('change', onChange)
  }, [])
  return isMobile
}
